module.exports = "/_next/static/images/EnsureDataPrivacy@2x-6e8c1fdbfe98cbfe1f1430302d73e5ff.png";